import React from "react";
import {IconButton, TextField} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

interface NumberFilterProps {
    label: string;
    value: number;
    setFilter: (value: string) => void;
    removeFilter: () => void;
    min?: number;
    max?: number;
    isMobile: boolean;
}

const NumberFilter: React.FC<NumberFilterProps> = ({label, value, setFilter, removeFilter, min, max, isMobile}) => (
    <TextField
        label={label}
        value={value}
        onChange={(e) => setFilter(e.target.value)}
        fullWidth={isMobile}
        variant="standard"
        margin="normal"
        type="number"
        InputProps={{
            endAdornment: value ? (
                <IconButton
                    onClick={removeFilter}
                    size="small"
                >
                    <ClearIcon/>
                </IconButton>
            ) : null,
            inputProps: {min, max}
        }}
        sx={{minWidth: 180}}
    />
);

export default NumberFilter;